import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { searchGlobal } from "@user-management-context/read/application/use-cases/admin/global-search/search-global";
import { selectGlobalSearch } from "@user-management-context/read/application/use-cases/admin/global-search/selectors/global-search-selectors";

export function useAdminGlobalSearch() {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useAppSelector(selectGlobalSearch);

  const [query, setQuery] = useState("");

  useEffect(() => {
    if (query.length < 2) {
      return;
    }

    const timeout = setTimeout(() => {
      dispatch(searchGlobal({ query }));
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [query, dispatch]);

  return {
    query,
    setQuery,
    results: query.length < 2 ? null : data,
    isLoading,
  };
}
